
<input type="text"
  #inputControl
  [name]="name"
  (keydown.enter)="trySelect()"
  [placeholder]="placeholder"
  (blur)="onBlur()"
  (click)="click($event)"
  [id]="id"
  [formControl]="myControl"
  class="form-control"
  [matAutocomplete]="auto"
  >

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" >
    @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">
        <span [innerHTML]="option"></span>
      </mat-option>
    }
  </mat-autocomplete>
